module.exports = __webpack_public_path__ + "static/media/text-align-right-white.4bc76a55.svg";